import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import ESGco2calc from "./ESGco2calc";
import ESGselect from "./ESGselect";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";

function ESGrating() {
  const [isCo2Calc, setIsCo2Calc] = useState(true);
  const [isSelect, setIsSelect] = useState(true);

  // 상태를 상위 컴포넌트로 옮김
  const [scope1Inputs, setScope1Inputs] = useState({});
  const [scope2Inputs, setScope2Inputs] = useState({});
  const [scope3Inputs, setScope3Inputs] = useState({});

  return (
    <Container>
      <Row style={{ justifyContent: "center", padding: "10px" }}>
        <Col
          md={5}
          style={{
            justifyContent: "center",
            paddingTop: "30px",
            paddingBottom: "50px",
          }}
        >
          <Card
            style={{
              padding: "20px",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
              backgroundColor: "transparent",
              border: "1px solid white",
              borderRadius: "8px",
            }}
          >
            <Card.Body>
              <h1
                style={{
                  fontSize: "1.8em",
                  paddingBottom: "20px",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => setIsCo2Calc(!isCo2Calc)}
              >
                {isCo2Calc ? (
                  <AiFillCaretDown style={{ marginRight: "10px" }} />
                ) : (
                  <AiFillCaretRight style={{ marginRight: "10px" }} />
                )}
                <strong className="purple">온실가스 계산기</strong>
              </h1>
              {isCo2Calc && (
                <ESGco2calc
                  scope1Inputs={scope1Inputs}
                  setScope1Inputs={setScope1Inputs}
                  scope2Inputs={scope2Inputs}
                  setScope2Inputs={setScope2Inputs}
                  scope3Inputs={scope3Inputs}
                  setScope3Inputs={setScope3Inputs}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col
          md={5}
          style={{
            justifyContent: "center",
            paddingTop: "30px",
            paddingBottom: "50px",
          }}
        >
          <Card
            style={{
              padding: "20px",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
              backgroundColor: "transparent",
              border: "1px solid white",
              borderRadius: "8px",
            }}
          >
            <Card.Body>
              <div
                style={{
                  display: "flex", // Flexbox 적용
                  justifyContent: "space-between", // 텍스트와 버튼을 양쪽 끝으로 배치
                  alignItems: "center", // 세로 정렬 중앙 맞춤
                  width: "100%", // 전체 컨테이너 너비를 기준으로 정렬
                }}
              >
                <h1
                  style={{
                    fontSize: "1.8em",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    margin: 0, // 추가적인 마진 제거
                  }}
                  onClick={() => setIsSelect(!isSelect)}
                >
                  {isSelect ? (
                    <AiFillCaretDown style={{ marginRight: "10px" }} />
                  ) : (
                    <AiFillCaretRight style={{ marginRight: "10px" }} />
                  )}
                  <strong className="purple">평가</strong>
                </h1>
                <button
                  style={{
                    padding: "10px 15px",
                    fontSize: "1em",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const youtubeUrl =
                      "https://www.youtube.com/watch?v=IOci-BoDz9A"; // 유튜브 링크
                    window.open(youtubeUrl, "_blank"); // 새 탭에서 열기
                  }}
                >
                  교육 영상
                </button>
              </div>
              {isSelect && <ESGselect />}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ESGrating;
